import { render } from "./DonationAmount.vue?vue&type=template&id=59b343d4&scoped=true"
import script from "./DonationAmount.vue?vue&type=script&lang=js"
export * from "./DonationAmount.vue?vue&type=script&lang=js"

import "./DonationAmount.vue?vue&type=style&index=0&id=59b343d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b343d4"]])

export default __exports__